import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell, Modal, Box, Grid,
} from '@mui/material';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../styles/MyStyles";
import {GetLookupMenuItems} from "../../logic/LookupHelper";
import {CreateDataUpdateTicket} from "../../logic/TicketHelper";

const LimitRequestPage = () => {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [showRedirectModal, setShowRedirectModal] = useState(false);

    const [request, setRequest] = useState({
        assetId: '',
        volume: '',
        reason: ''
    });

    useEffect(() => {
    }, []);

    const validateForm = () => {
        let newErrors = {};

        if (request.assetId === '') {
            newErrors.assetId = 'Asset is required.';
        }

        if (request.volume === '') {
            newErrors.volume = 'Volume is required.';
        } else if (isNaN(request.volume)) {
            newErrors.volume = 'Volume must be number.';
        }

        if (!request.reason.trim()) {
            newErrors.reason = 'Reason is required.';
        }

        return newErrors;
    };

    const handleFieldChange = (event) => {
        setRequest({
            ...request,
            [event.target.name]: event.target.value,
        });
    };

    const handleSendRequest = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            await CreateDataUpdateTicket(1, request);

            setShowRedirectModal(true);

        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleCloseRedirectModal = (redirect) => {
        if (redirect) {
            navigate('/tickets');
        } else {
            handleGoBack()
        }
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                New Operation Limit Request
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSendRequest}>
                    Send request
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="assetId"
                                label="Asset"
                                select
                                value={request.assetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.assetId}
                                helperText={errors.assetId}
                            >
                                {GetLookupMenuItems('asset')}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Volume</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="volume"
                                label="Volume"
                                value={request.volume}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.volume}
                                helperText={errors.volume}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Reason</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="reason"
                                label="Reason"
                                value={request.reason}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                rows={2}
                                multiline={true}
                                error={!!errors.reason}
                                helperText={errors.reason}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            {showRedirectModal && (<Modal open={showRedirectModal} onClose={() => handleCloseRedirectModal(true)}>
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography variant="h6" component="h2">
                        This action creates a new Ticket, the status of which you can see in the Tickets section.
                    </Typography>
                    <Grid container spacing={2} marginTop={3}>
                        <Grid item xs={12} md={12}>
                            <StyledButtonOrange onClick={() => handleCloseRedirectModal(true)}>
                                Ok
                            </StyledButtonOrange>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>)}

        </Container>
    );
};

export default LimitRequestPage;
